import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BaseSiteService, CmsService, PageMeta, PageMetaConfig, PageMetaService, UnifiedInjector } from '@spartacus/core';
import { combineLatest, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustompagemetatitleService extends PageMetaService {
  currentSite: string='';

 private readonly fallbackDescription: Record<string, string> = {
      'seqirusb2b-flu360': `flu360 offers clinical, financial, and operational solutions for your flu vaccination
  business year-round. Learn more and partner with CSL Seqirus at flu360.com`,
      'seqirusb2b-uk': `Partner with CSL Seqirus via flu360 UK. Access reliable flu vaccine ordering, educational resources, and year-round business support for UK healthcare professionals.`,
    };

  constructor(protected override cms: CmsService,
    protected override unifiedInjector: UnifiedInjector,
    protected override pageMetaConfig: PageMetaConfig,
    @Inject(PLATFORM_ID) protected override platformId: string,
    private baseSiteService:BaseSiteService){
    super(cms,unifiedInjector,pageMetaConfig,platformId);
  }

  public override getMeta():Observable<PageMeta>{ 

    return combineLatest([super.getMeta(),this.baseSiteService.getActive()]).pipe(
      map(([meta,baseSite]) => {
        let siteTitle="";
        if(baseSite == 'seqirusb2b-flu360'){
          siteTitle = 'CSL Seqirus flu360';
        }
        else if(baseSite == 'seqirusb2b-uk'){
          siteTitle = 'flu360 UK';
        }

        const description = (meta?.description || this.fallbackDescription[baseSite] || '')
    .replace(/\s+/g, ' ')
    .trim();

        if(meta?.title && meta?.title != "undefined"){
          return {
          ...meta,
          title: `${meta?.title} | ${siteTitle}`,
           description: description,
          };
        }
        else{
          return{
            ...meta,title:`${siteTitle}`,
             description: description
          };
        }
      })
    );
  }

}


